<script>
  import { station } from "./stores/station.js";
  import { onMount, onDestroy } from "svelte";
  import { push, pop, replace, location, querystring } from "svelte-spa-router";
  import Player from "./Player.svelte";
  import Search from "./Search.svelte";
  import NowPlaying from "./NowPlaying.svelte";
  import CooldownTimer from "./CooldownTimer.svelte";
  import {
    addSongCooldown,
    saySomethingCooldown,
  } from "./stores/cooldownTimer.js";
  import Playlist from "./Playlist.svelte";
  import qs from "qs";
  import QRCode from "./QRCode.svelte";
  import { joinStation, leaveStation } from "./firebase.js";
  import { bgColor } from "./stores/background_color.js";
  import SaySomething from "./SaySomething.svelte";
  import Messages from "./Messages.svelte";
  import { messages } from "./stores/messages.js";
  import { getRandomColor } from "./utils.js";

  $: showSearch = qs.parse($querystring).search;

  $: showSaySomething = qs.parse($querystring).saySomething;

  let codeShadows = [getRandomColor(), getRandomColor(), getRandomColor()];

  $: shadowsText = `text-shadow: -10px 0px 0px ${codeShadows[2]}20, -20px 0px 0px ${codeShadows[1]}20, -30px 0px 0px ${codeShadows[0]}20;`;

  console.log(codeShadows);

  let player;

  const STATUS = {
    LOADING: {
      msg: "Loading...",
    },
    SEARCHING: {
      msg: "Finding Station...",
    },
    CREATING_NEW: {
      msg: "Starting a new station...",
    },
    NOT_FOUND: {
      msg: "Station not found :(",
    },
    OK: {
      msg: "Tuned in",
    },
  };

  $: status = STATUS.LOADING;

  let qrSize;

  $: {
    qrSize = Math.round(window.innerWidth / 5);
    qrSize = Math.min(qrSize, 132);
    qrSize = Math.max(qrSize, 78);
  }

  async function connect() {
    if (status == STATUS.SEARCHING) {
      console.log("already loading station");
      return;
    }

    let targetId = $location.replace("/", "").toUpperCase();

    if ($station) {
      if ($station.id == targetId) {
        console.log("already in station");
        return;
      } else {
        leaveStation();
      }
    }

    if (targetId) {
      status = STATUS.SEARCHING;
      await joinStation(targetId);
      console.log("connect: " + targetId);
    }
  }

  let us_bgColor;
  onMount(() => {
    connect();
    us_bgColor = bgColor.subscribe((color) => {
      codeShadows.push(color);
      codeShadows.shift();
      codeShadows = codeShadows;
    });
  });

  //if url changed
  const us_location = location.subscribe((loc) => {
    if (status === STATUS.LOADING) return;
    if (loc === "/") {
      leaveStation();
    } else {
      connect();
    }
  });

  const us_station = station.subscribe((_station) => {
    if (!_station || _station === null) {
      status = STATUS.NOT_FOUND;
    } else {
      status = STATUS.OK;
    }

    status = status;
  });

  function openSearch() {
    if ($addSongCooldown.show) return;
    let urlParams = qs.parse($querystring);
    if (urlParams.hasOwnProperty("search")) {
      urlParams.search = true;
      replace($location + "?" + qs.stringify(urlParams));
    } else {
      urlParams.search = true;
      push($location + "?" + qs.stringify(urlParams));
    }
  }

  function openSaySomething() {
    if ($saySomethingCooldown.show) return;
    let urlParams = qs.parse($querystring);
    if (urlParams.hasOwnProperty("saySomething")) {
      urlParams.saySomething = true;
      replace($location + "?" + qs.stringify(urlParams));
    } else {
      urlParams.saySomething = true;
      push($location + "?" + qs.stringify(urlParams));
    }
  }

  function play(e) {
    player.playVideo(e.detail);
  }

  onDestroy(() => {
    us_bgColor();
    us_location();
    us_station();
    leaveStation();
  });
</script>

<div class="station">
  <div class="top">
    <div class="qrAndCode">
      <QRCode
        codeValue={"https://house-party.netlify.app/#" + $location}
        squareSize={qrSize}
      />
      <h1 style="color: {$bgColor}; {shadowsText}">
        {$location.split("/")[1].substring(0, 4).toUpperCase()}
      </h1>
    </div>
    <div class="flex items-center gap-3 box-border text-xl py-2">
      <div class="cursor-pointer"
        on:keydown={{}}
        on:click={() => {
          push(`/`);
        }}
      >
        <i
          style="color: #3b3b3bf0;"
          class="fa-solid fa-house text-[#3b3b3bf0] p-2 rounded-[100%] border-[2px] border-[#3b3b3bf0] border-solid"
        ></i>
      </div>
      <div
        class="statusColor"
        style="background-color: {status == STATUS.OK
          ? 'greenyellow'
          : 'orange'}"
      />

      <h2>{status.msg}</h2>
    </div>
  </div>
  {#if $station}
    <div class="player">
      <Player bind:this={player} />
    </div>

    <NowPlaying />

    {#if $messages.length > 0}
      <Messages />
    {/if}

    <Playlist on:play={play} />

    <div class="buttons">
      <div title="Add a song to the playlist" class="addBtn" on:click={openSearch} on:keydown={{}}>
        <CooldownTimer cooldownTimer={addSongCooldown} />
        <div
          class="addBtnIcons"
          style="color:{$addSongCooldown.show ? '#e6e6e6' : '#878787'}"
        >
          <i class="noteIcon fas fa-music" />
          <!-- <i class="fas fa-plus" /> -->
        </div>
      </div>

      <div title="Post a message!" class="addBtn" on:click={openSaySomething} on:keydown={{}}>
        <CooldownTimer cooldownTimer={saySomethingCooldown} />
        <div
          class="addBtnIcons"
          style="color:{$saySomethingCooldown.show ? '#e6e6e6' : '#878787'}"
        >
          <i class="chatIcon fas fa-comment" />
          <!-- <i class="fas fa-plus" /> -->
        </div>
      </div>
    </div>
    {#if showSearch}
      <Search on:close={pop} />
    {/if}

    {#if showSaySomething}
      <SaySomething on:close={pop} />
    {/if}
  {/if}
</div>

<style>
  :global(#qrcode) {
    width: 20vw;
    min-width: 78px;
    max-width: 132px;
  }
  .station {
    text-align: center;
    margin: 0 auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh;
  }
  .statusColor {
    width: 8px;
    height: 8px;
    /* margin: 7px; */
    border-radius: 100px;
  }
  h1 {
    padding-right: 20px;
    /* padding: 0; */
    margin: 0;
    font-family: "Paytone One";
    /* font-size: 183px; */
    font-size: clamp(90px, 150px, 31vw - 38px);

    line-height: 100px;
    transform: translateY(-2px);
    background-clip: text;
    filter: hue-rotate(10deg) brightness(0.75) saturate(2.5);
  }

  h2 {
    font-family: "Baloo 2";
    line-height: 40px;
    margin: 0;
  }

  .top {
    display: flex;
    flex-direction: column;
    max-width: 640px;
    width: 100%;
    color: black;
    background: white;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 15px;
    align-items: start;
    margin-top: 20px;
    padding-bottom: 6px;
    box-sizing: border-box;
  }

  .buttons {
    z-index: 100;
    width: 100%;
    margin-bottom: 20px;
    bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 22px;
    position: sticky;
    margin-top: 10px;
  }

  .addBtn {
    position: relative;
    width: 80px;
    height: 80px;
    max-width: 100px;
    max-height: 100px;
    background: rgb(255, 255, 255);
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 1) 73%,
      rgba(233, 233, 233, 1) 94%,
      rgba(217, 217, 217, 1) 100%
    );
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #606060;
    box-shadow: 0px 18px 10px -10px #00000059;
    cursor: pointer;
  }

  .addBtnIcons {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    transition: color 500ms;
  }

  .addBtnIcons i {
    position: absolute;
  }

  .noteIcon {
    transform: translateX(-3px);
  }

  .addBtnIcons i:nth-child(2) {
    font-size: 16px;
    margin-left: 30px;
  }

  .player {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .qrAndCode {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 18px;
  }

  @media (max-width: 576px) {
    .top {
      margin: 0;
      border-radius: 0;
      /* border-top-left-radius: 0;
      border-top-right-radius: 0; */
    }

    .player {
      margin-top: 0;
    }
  }

  @media (max-width: 388px) {
  }
</style>
